"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowPicker = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindWorkflows_1 = require("../hooks/useFindWorkflows");
const WorkflowPicker = props => {
    const { value: workflowId, disabled, textFieldProps, isLoading: isLoadingProp = false, onChange } = props;
    const [search, setSearch] = (0, react_1.useState)('');
    const [selected, setSelected] = (0, react_1.useState)();
    const [workflows, setWorkflows] = (0, react_1.useState)([]);
    const debouncedSearch = (0, core_ui_1.useDebounce)(search, 300);
    const { workflowList, isLoading: isFinding, error, findWorkflows } = (0, useFindWorkflows_1.useFindWorkflows)();
    const isLoading = isFinding || isLoadingProp;
    (0, react_1.useEffect)(() => {
        findWorkflows({ search: debouncedSearch });
    }, [debouncedSearch, findWorkflows]);
    (0, react_1.useEffect)(() => {
        workflowList && setWorkflows(workflowList.data);
    }, [workflowList]);
    (0, react_1.useEffect)(() => {
        setSelected(selected => {
            // only find updated value from workflows when workflowId
            // changed to avoid re-rendering when searching
            return selected && selected.id === workflowId
                ? selected
                : workflows.find(workflow => workflow.id === workflowId);
        });
    }, [workflowId, workflows]);
    return (react_1.default.createElement(lab_1.Autocomplete, { fullWidth: true, loading: isLoading, disabled: disabled, value: selected || null, options: workflows, getOptionLabel: option => option.name, getOptionSelected: option => option.id === workflowId, onInputChange: (_, value) => setSearch(value || ''), onChange: (_, value) => {
            const workflow = value || undefined;
            setSelected(workflow);
            onChange === null || onChange === void 0 ? void 0 : onChange(workflow);
        }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Workflow', placeholder: 'Select Workflow', error: !!((error === null || error === void 0 ? void 0 : error.message) || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.error)), helperText: (error === null || error === void 0 ? void 0 : error.message) || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.helperText) }, textFieldProps, { InputProps: Object.assign(Object.assign({}, params.InputProps), textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps) }))) }));
};
exports.WorkflowPicker = WorkflowPicker;
exports.default = exports.WorkflowPicker;
//# sourceMappingURL=WorkflowPicker.js.map